import { CSSResultGroup, TemplateResult, html } from 'lit';
import { OutlineElement } from '../../base/outline-element/outline-element';
import { customElement } from 'lit/decorators.js';
import componentStyles from './sic-stats-block.css.lit';

/**
 * The SicStatsBlock component
 * @element sic-stats-block
 *
 * @slot default - pass in <sic-stat> components.
 * @slot icon - pass in <sic-icon> component.
 * @slot heading
 * @slot description
 * @slot cta
 *
 * Lightdom styles in sic-stats-block.lightdom.css included in /shared.css
 */
@customElement('sic-stats-block')
export class SicStatsBlock extends OutlineElement {
  static styles: CSSResultGroup = [componentStyles];

  render(): TemplateResult {
    return html`
      <section class="sic-stats-block">
        <div class="sic-stats-block--wrapper">
          <div class="sic-stats-block--icon">
            <slot name="icon"></slot>
          </div>
          <div class="sic-stats-block--content">
            <div class="sic-stats-block--info">
              <slot name="heading"></slot>
              <slot name="description"></slot>
              <slot name="cta"></slot>
            </div>
            <div class="sic-stats-block--stats">
              <slot></slot>
            </div>
          </div>
        </div>
      </section>
    `;
  }
}
